module.exports = __webpack_public_path__ + "media/images/icons/icon_bell-7c7a9a61c522389276b0144c6c3f3a47.svg";